import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'top_match_card_cell';
export const useTopMatchCardCellTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => {
  return useTranslation('entities', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    tag: 'Карточка',
    fio: 'ФИО',
    card_id: 'ID карточки',
    no_data: 'Нет данных',
    no_data_tooltip: 'Не найдена карточка с лицом из совпадения',
    no_face: 'Не найдено лицо из совпадения',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    tag: 'Card',
    fio: 'Full name',
    card_id: 'Card ID',
    no_data: 'No data',
    no_data_tooltip: 'Card with the matched face was not found',
    no_face: 'Matched face not found',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    tag: 'Cartão',
    fio: 'Nome completo',
    card_id: 'ID do cartão',
    no_data: 'Sem dados',
    no_data_tooltip: 'Cartão com a face correspondente não foi encontrado',
    no_face: 'Face correspondente não encontrada',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    tag: 'Tarjeta',
    fio: 'Nombre completo',
    card_id: 'ID de la tarjeta',
    no_data: 'Sin datos',
    no_data_tooltip: 'No se encontró la tarjeta con el rostro coincidente',
    no_face: 'No se encontró el rostro coincidente',
  },
}) : {}) as Record<string, unknown>;
